import { tv } from 'tailwind-variants'

export const separator = tv({
  slots: {
    container: 'h-px overflow-hidden',
    line: 'border-b border-ui-grey-50',
  },
  variants: {
    lineType: {
      solid: {
        line: 'border-solid',
      },
      dashed: {
        line: 'border-dashed',
      },
    },
  },
  defaultVariants: {
    lineType: 'dashed',
  },
})
